/**
 * 统计报表
 */

import instance from '@/utils/axios';

/**
 * 查询原始数据
 * sn 设备号 list
 * eventId 报警事件号
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * busiType 1 业务类型（返回数据类型）：1-报警原始数据，2-BM4000原始数据
 * dataScale 数据尺度 1-秒 2-分 3-小时
 */
export function queryOrdata(data) {
  return instance.get('/stat/queryOrdata', {
    params: { ...data }
  });
}

/**
 * 获取日年月数据
 * sn 设备号 list
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * times list 多个时间 与上方两个时间互斥
 * busiType 报表类型 1-多日期报表 2-单区间报表
 * dataType 数据类型
 * statType 统计类型 1-日报 2-月报 3-年报
 */
export function queryOrDataReport(data) {
  return instance.post('/stat/queryOrdataReport', { ...data });
}

/**
 * 获取报警次数
 * @param {Object} data
 * @param {string[]} data.sn 设备号 list
 * @param {number} data.beginTime 查询开始时间
 * @param {number} data.endTime 查询结束时间
 * @param {''|number} data.alarmType 报警类型 空-所有
 * @param {1|2|3|4|11|12|21|22|23|24|31|32|33|34} data.busiType 业务类型
 * - 1-分类总次数，2-月度总次数，3-每时刻总次数,4-年度分类总次数
 * - 11-按设备统计，12-按设备分类统计
 * - 21-按机构统计，22-按机构分类统计，23-按机构设备统计，24-按机构设备分类统计
 * - 31-按任务统计，32-按任务分类统计，33-按任务设备统计，34-按任务设备分类统计
 */
export function getAlarmData(data) {
  return instance.post('/stat/alarmData', { ...data });
}
/**
 * 将图表保存到服务器
 * @param {设备号} sn
 * @param {base64图片} pics
 */
export function createPDF(data) {
  return instance.post('/stat/genDailyReport', { ...data });
}

/**
 * 设备状态统计
 * @param {*} data
 */
export function getDeviceState(data) {
  return instance.post('/stat/deviceState', { ...data });
}

export function getDetectData(data) {
  return instance.post('/stat/detectData', { ...data });
}

export function exportHisStat(data) {
  return instance.post('/stat/genAlarmDataReport', { ...data });
}

export function exportDetectStat(data) {
  return instance.post('/stat/genDetectDataReport', { ...data });
}

/**
 * 获取 检测记录->数据曲线 维度列表
 * @param {{sn: string[]}} data
 * @returns
 */
export function getOrdataChartItems(data) {
  return instance.post('/stat/queryOrdataChartItem', { ...data });
}

/**
 * 获取 检测记录->数据曲线 数据
 * @param {{cols: [], busiType: 1, dataScale: 1, beginTime: number, endTime: number, latestFlag: 0, sn: string, dataInterval: number, dataIntervalType: 's'}} data
 * @returns
 */
export function getOrdataChartData(data) {
  return instance.post('/stat/queryOrdataChart', { ...data });
}

/**
 * 获取cd603数据
 * @param {Object} data
 * @param {string[]} data.sn
 * @param {string[]} data.officeId
 * @param {1|2|3} data.busiType 1: 按设备统计 2: 按单位统计 3：按月度统计
 * @param {number} data.beginTime
 * @param {number} data.endTime
 * @returns
 */
export function getCD603StatData(data) {
  return instance.post('/stat/cd603Data', { ...data });
}

/**
 * 获取cd603数据
 * @param {Object} data
 * @param {string[]} data.sn
 * @param {string[]} data.officeId
 * @param {1|2|3} data.busiType 1: 按设备统计 2: 按单位统计 3：按月度统计
 * @param {number} data.beginTime
 * @param {number} data.endTime
 * @returns
 */
export function getCD603AlarmStatData(data) {
  return instance.post('/stat/cd603Alarm', { ...data });
}

/**
 * 导出cd603数据
 * @param {Object} data
 * @param {string[]} data.sn
 * @param {string[]} data.officeId
 * @param {0} data.exportType
 * @param {string[]} data.pics
 * @param {1|2|3} data.busiType 1: 按设备统计 2: 按单位统计 3：按月度统计
 * @param {number} data.beginTime
 * @param {number} data.endTime
 * @returns
 */
export function exportCD603StatData(data) {
  return instance.post('/stat/genCd603DataReport', { ...data });
}
